import React from 'react';

export default () => (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.5" cy="10.5" r="8.25" stroke="currentColor" strokeWidth="1.5" />
    </svg>
);